import { atom } from 'infrastructure/state/jotai.wrapper'
import { parseCrosswalkData } from './parsers'
import {
  CrosswalkMappingSetType,
  StandardAlignmentInputType,
} from 'domains/scope-and-sequence/types'
import { isCompleteCrosswalk } from 'domains/scope-and-sequence/utility'
import { alignmentKey } from './utility'
import { objectFieldSort } from 'utility'

export const currentSheetRawDataAtom = atom<string[][]>()

export const parsedCurrentSheetAtom = atom((get) => {
  const rawData = get(currentSheetRawDataAtom)
  if (!rawData) return
  const parsed = parseCrosswalkData(rawData)
  parsed?.parsed.sort(
    objectFieldSort('sourceStandardCode', 'targetStandardCode'),
  )
  return parsed
})

export const currentCrosswalkIdAtom = atom<number>()

export const newCrosswalkDataAtom = atom<
  Partial<Omit<CrosswalkMappingSetType, 'id'>>
>({
  method: 'ingested',
  status: 'inactive',
})

export const canCreateCrosswalk = atom((get) => {
  const rawData = get(newCrosswalkDataAtom)
  return isCompleteCrosswalk(rawData)
})

export const alignmentInputsAtom = atom<StandardAlignmentInputType[]>((get) => {
  const parsedData = get(parsedCurrentSheetAtom)
  if (!parsedData) return []
  const alignments = parsedData.parsed.reduce<
    Record<string, StandardAlignmentInputType>
  >((acc, data) => {
    const { sourceStandardCode, targetStandardCode, rating, note } = data
    if (!sourceStandardCode || !targetStandardCode) return acc
    const key = alignmentKey({ sourceStandardCode, targetStandardCode })
    if (key in acc) return acc
    const alignment: StandardAlignmentInputType = {
      source_standard_code: sourceStandardCode,
      target_standard_code: targetStandardCode,
      alignment_type: rating,
      rating: rating.toLowerCase() === 'full' ? 100 : 50,
    }
    if (note) {
      alignment.note = note
    }
    return { ...acc, [key]: alignment }
  }, {})
  return Object.values(alignments)
})

export const alignmentCountsAtom = atom<Record<string, number>>((get) => {
  const parsedData = get(parsedCurrentSheetAtom)
  if (!parsedData) return {}
  return parsedData.parsed.reduce<Record<string, number>>((acc, data) => {
    const { sourceStandardCode, targetStandardCode } = data
    if (!sourceStandardCode || !targetStandardCode) return acc
    const key = alignmentKey({ sourceStandardCode, targetStandardCode })
    return {
      ...acc,
      [key]: (acc[key] ?? 0) + 1,
    }
  }, {})
})
